<template>
	<div v-if="formState">
		<el-form-item v-if="!isExcludeFormItem && formState.payload?.props?.visible !== false" :prop="formState.payload.field" :rules="getRules()">
			<template #label>
				{{ formState.payload.label }}
				<el-tooltip v-if="formState.payload.labelTip" effect="dark"
					placement="top-start">
					<div slot="content" v-html="formState.payload.labelTip.replace(/\n/g, '<br>')"></div>
					<i class="el-icon-question" style="cursor: pointer;" />
				</el-tooltip>
			</template>
			<component :is="formState.type" :key="formState.payload.field" :field="formState.payload.field"
				v-model="value" v-bind="formState.payload?.props" :rootFormData="rootFormData"
				:rootFormDataOptions="rootFormDataOptions" :form-state="formState" :config="config">
			</component>
		</el-form-item>
		<template v-else>
			<component :is="formState.type" :key="formState.payload.field" :field="formState.payload.field"
				v-model="value" v-bind="formState.payload?.props" :rootFormData="rootFormData"
				:rootFormDataOptions="rootFormDataOptions" :form-state="formState" :config="config"
				v-if="formState.payload?.props?.visible !== false" style="margin-bottom: 20px;"></component>
		</template>
		<FormItemComp ref="FormItemComp" :config="config" :rootFormData="rootFormData"
			:rootFormDataOptions="rootFormDataOptions" :form-state="getNext()"></FormItemComp>
	</div>
</template>

<script>
import * as Comp from './components/index.js';
import _ from 'lodash'
import { evaluateConditionGroup, conditionHandlers } from './formItemFactory.js'
import { effectHandlers } from './effectFunction.js';
export default {
	name: 'FormItemComp',
	components: {
		..._.omit(Comp, 'FORM_ITEM_TYPE')
	},
	props: {
		formState: {
			type: Object,
			default: null
		},
		rootFormData: Object,
		rootFormDataOptions: Object,
		config: Object,
	},
	data() {
		return {
			excludeFormItemList: [
				Comp.FORM_ITEM_TYPE.WkBlockText,
				Comp.FORM_ITEM_TYPE.WkModalForm,
				Comp.FORM_ITEM_TYPE.WkTitle,
				Comp.FORM_ITEM_TYPE.WkHonorModalForm,
			],
			effectList: [] // 影响当前表单项的表单项列表	本级以及以上
		}
	},
	computed: {
		isExcludeFormItem() {
			return this.excludeFormItemList.includes(this.formState.type)
		},
		value: {
			get() {
				return this.formState.payload.value
			},
			async set(v) {
				const value = this.formState.payload.value;
				if (_.isEqual(v, value)) {
					this.formState.payload.value = v;
					return
				}

				if (this.formState.payload.berforeChange) {
					await this.formState.payload.berforeChange({
						newValue: v,
						oldValue: value,
						target: this
					})
				}
				this.formState.payload.value = v;
				if (this.formState.payload.onChange) {
					this.formState.payload.onChange({
						newValue: v,
						oldValue: value,
						target: this
					})
				}
			}
		},
		beDependentOn() {
			if (!this.formState) {
				return;
			};
			const list = this.formState.payload?.dependencies || [];
			return list.reduce((pre, key) => {
				pre[key] = this.rootFormData[key];
				return pre;
			}, {})
		},
		affectingValues() {
			// 确保 formState 和 payload 都存在
			if (!this.formState || !this.formState.payload) {
				return {};
			}
			// 确保 affectedBy 存在且是数组
			const affectedBy = this.formState.payload?.dependencies;
			if (!Array.isArray(affectedBy)) {
				return {};
			}
			return affectedBy.reduce((acc, field) => {
				acc[field] = this.rootFormData[field];
				return acc;
			}, {});
		},
		getRules() {
			return () => {
				if (this.formState.payload?.props?.visible === false) {
					return [];
				}
				return this.formState.payload.rules || [];
			}
		}
	},
	methods: {
		getNext() {
			let current = this.formState
			if (!current) {
				return null
			}
			const acients = []
			acients.unshift(current)
			while ((current = current.parent)) {
				acients.unshift(current)
			};

			return this.formState.next(this.formState, acients, this.rootFormData)
		},
		handleEffects(values) {
			const effects = this.formState.payload.effects;
			if (!Array.isArray(effects)) {
				return;
			}

			effects.forEach(async (effect) => {
				const { condition, action } = effect;

				// 执行表达式判断
				if (condition && conditionHandlers[condition?.type](values, condition?.expression)) {
					// 执行对应的动作
					if (action.type === 'fetchOptions') {
						await effectHandlers[action.type](this, action.value);
					} else if(action.type === 'function') {
						action.value(this)
					}else {
						effectHandlers[action.type](this, action.value);
					}
				}
				// if (effect.condition(values)) {
				//     effect.action(this);
				// }
			});
		}
	},
	watch: {
		beDependentOn: {
			handler(val, oldValue) {
				if (_.isEqual(val, oldValue)) {
					return;
				};
				if (!this.formState) {
					return;
				}
				const conditions = this.formState.payload?.action_conditions || [];
				const data = conditions.find((condition) => {
					return evaluateConditionGroup(condition, val)
				});
				if (data) {
					let { effects } = data;
					effects = _.toArray(effects);
					effects.forEach((effect) => {
						if (_.isString(effect)) { };
						if (effect === 'isNotDisabled') {
							this.$set(this.formState?.payload?.props, 'disabled', false)
						}
						if (effect === 'isDisabled') {
							this.$set(this.formState?.payload?.props, 'disabled', true)
						}

						if (effect === 'clear') {
							if (!_.isEqual(this.formState.payload.value, [])) {
								this.formState.payload.value = []
							}
						}
					})
				}
			},
			deep: true,
			immediate: true,
		},
		affectingValues: {
			handler(newVal, oldValue) {
				if (_.isEqual(newVal, oldValue)) {
					return;
				};
				if (!this.formState) {
					return;
				}
				// 确保 formState 和 payload 都存在
				if (!this.formState || !this.formState.payload) {
					return;
				}
				this.handleEffects(newVal);
			},
			deep: true,
			immediate: true
		}
	}
}
</script>

<style>
.ant-form-item-label {
	padding-right: 10px !important;
}
</style>